import React from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import CustomInput from "../../../../components/TextField/TextFeild";
import { updateUserProfile } from "../../../../store/slices/authSlice";
import FacebookIcon from "@mui/icons-material/Facebook";

const validationSchema = Yup.object({
  facebook: Yup.string().url().nullable(),
});

const Facebook = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      facebook: user?.attributes.facebook?.id
        ? `https://www.facebook.com/${user?.attributes.facebook?.id}`
        : "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting, setFieldError }) => {
      try {
        const extractUsername = (url) => {
          if (!url) return "";
          try {
            let urlObj = new URL(url.startsWith("http") ? url : `https://${url}`);
            return urlObj.pathname.replace(/^\/+/, "").split("/")[0]; // Extract username
          } catch (error) {
            return url;
          }
        };

        let payload = {};
        if (values.facebook) {
          payload.facebook = { id: extractUsername(values.facebook) };
        }else{
          payload.facebook ={};
        }
        const isForStation = user?.attributes?.isOwner == false ? true : false;
        await dispatch(
          updateUserProfile({
            message: "Facebook Page Updated Successfully.",
            values: payload,
            isForStation
          })
        );
      } catch (error) {
        console.error("Error updating Facebook:", error);
        setFieldError("facebook", "Failed to update Facebook page. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="ps-3">
      <form className="form_div row w-100 " onSubmit={formik.handleSubmit}>
        <div className="InnerHeading">
          <h4>Facebook</h4>
        </div>
        <div className="form-card col-9 d-flex justify-content-around align-items-center">
          <div className="form-elements w-75 d-flex align-items-end">
            <FacebookIcon
              style={{
                color: "#517FA4",
                width: "35px",
                fontSize: "30px",
                marginBottom: "5px",
                marginRight: "5px",
              }}
            />
            <CustomInput
              label="Facebook page address"
              id="facebook"
              name="facebook"
              value={formik.values.facebook}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.facebook && formik.errors.facebook}
            />
          </div>
          <div className="button-div">
            <button
              type="submit"
              className="btn btn-primary custom-submit-btn"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? (
                <>
                  Updating...
                </>
              ) : (
                "Update"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Facebook;
